export default __webpack_public_path__ + "static/media/goat.76f50845.png";